import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";

var moment = require('moment');

import CryptoJS from 'crypto-js';
import NP from 'number-precision';
var dateUtils = {
  todayTimestamp: function todayTimestamp() {
    var format = 'YYYY-M-D';
    var date = moment().utcOffset(8).format(format);
    return moment(date, format).unix();
  },
  nowHour: function nowHour() {
    var date = moment().utcOffset(8);
    return date.hour();
  },
  timeStampToString: function timeStampToString(ts) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (format === undefined || format === '') {
      format = 'YYYY-MM-DD';
    }

    return moment.unix(ts).format(format);
  },
  timeStampToBeforeMonthString: function timeStampToBeforeMonthString(ts) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    if (format === undefined || format === '') {
      format = 'YYYY-MM-DD';
    }

    return moment.unix(ts).subtract(n, 'months').format(format);
  },
  timeStampToBeforeYearString: function timeStampToBeforeYearString(ts) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    if (format === undefined || format === '') {
      format = 'YYYY-MM-DD';
    }

    return moment.unix(ts).subtract(n, 'years').format(format);
  },
  timeStampToNormalDateTime: function timeStampToNormalDateTime(ts) {
    return moment.unix(ts).format('YYYY-MM-DD HH:mm:ss');
  },
  timeStampToDate: function timeStampToDate(ts) {
    return moment.unix(ts);
  },
  normalFormat: function normalFormat(ts) {
    return moment(new Date(ts)).format('YYYY-MM-DD HH:mm:ss');
  },
  normalFormatCus: function normalFormatCus(ts) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (format === undefined || format === '') {
      format = 'YYYY-MM-DD HH:mm:ss';
    }

    return moment(new Date(ts)).format(format);
  },
  normalUnix: function normalUnix(ts) {
    return moment(new Date(ts)).unix();
  },

  /**
   * 加密（需要先加载lib/aes/aes.min.js文件）
   */
  cyEncrypt: function cyEncrypt(ckey, word) {
    var key = CryptoJS.enc.Utf8.parse(ckey);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },

  /**
   * 解密
   */
  cyDecrypt: function cyDecrypt(ckey, word) {
    var key = CryptoJS.enc.Utf8.parse(ckey);
    var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
  numberFix: function numberFix(number, len) {
    // return (String(number).indexOf('9999999') !== -1 || String(number).indexOf('0000000') !== -1) && number !== parseInt(number) ? Number(number).toFixed(len).toLocaleString() : number
    return NP.round(number, len);
  }
};
export default dateUtils;